function NotFound() {
    return (
        <div id="not-found">
            <h1 className="text-center">Oops! Page Not Found.</h1>
        </div>
    );
}
 
export default NotFound;